import { useEffect, useRef } from 'react';

// returns the previous value of the argument
const usePrevious = <T>(value: T) => {
  const ref = useRef<T>(undefined);
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
};

export default usePrevious;
